import { useJobAdsFiltersStorage } from '../hooks/useJobAdsFiltersStorage'

import { useFiltersSelection } from './useFiltersSelectionTemplate'

export const useMoreFiltersSelection = () => {
  const { storageData, setStorageData } = useJobAdsFiltersStorage()

  const contractTypeHook = useFiltersSelection({
    isMultiSelection: true,
    typeKey: 'contractType',
  })
  const contractDurationHook = useFiltersSelection({
    isMultiSelection: true,
    typeKey: 'contractDuration',
  })
  const yearsOfExperienceHook = useFiltersSelection({
    isMultiSelection: false,
    isUnselectable: true,
    typeKey: 'yearsOfExperience',
  })
  const institutionTypeHook = useFiltersSelection({
    isMultiSelection: true,
    typeKey: 'institutionType',
  })

  const resetAllLocalValues = () => {
    contractTypeHook.resetLocalValue()
    contractDurationHook.resetLocalValue()
    yearsOfExperienceHook.resetLocalValue()
    institutionTypeHook.resetLocalValue()
  }

  const saveAllValues = () => {
    contractTypeHook.saveValue()
    contractDurationHook.saveValue()
    yearsOfExperienceHook.saveValue()
    institutionTypeHook.saveValue()

    // save in storage
    storeValues()
  }

  const storeValues = () => {
    setStorageData({
      ...storageData,
      contractType:
        Array.isArray(contractTypeHook.localValue) &&
        contractTypeHook.localValue?.length
          ? contractTypeHook.localValue
          : undefined,
      contractDuration:
        Array.isArray(contractDurationHook.localValue) &&
        contractDurationHook.localValue?.length
          ? contractDurationHook.localValue
          : undefined,
      yearsOfExperience:
        (yearsOfExperienceHook.localValue as string) || undefined,
      institutionType:
        Array.isArray(institutionTypeHook.localValue) &&
        institutionTypeHook.localValue?.length
          ? institutionTypeHook.localValue
          : undefined,
    })
  }

  return {
    contractTypeHook,
    contractDurationHook,
    yearsOfExperienceHook,
    institutionTypeHook,
    resetAllLocalValues,
    saveAllValues,
  }
}
